module.exports = __webpack_public_path__ + "assets/asp.net.39075c6e.svg";